import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import logoLicenciamiento from "../assets/transparencia/licenciamiento/logo.png"; 
import "./Admision.css"; // reutilizamos el mismo estilo base

const Licenciamiento = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="gestion-page">
      {/* Banner superior */}
      <div className="info-hero" >
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold text-uppercase">Rumbo al Licenciamiento</h1>
          <p className="lead">Comprometidos con la calidad educativa</p>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="container py-5 text-center" data-aos="fade-up">
             

        <h2 className="fw-bold text-primary mb-5">RUMBO AL LICENCIAMIENTO</h2>

    
        <h4 className="text-uppercase fw-bold text-dark">
          INSTITUTO DE EDUCACIÓN SUPERIOR TECNOLÓGICO PÚBLICO
        </h4>
        <h3 className="fw-bold text-primary mb-4">"GILDA LILIANA BALLIVIAN ROSADO"</h3>
     
        <img
          src={logoLicenciamiento}
          alt="Rumbo al Licenciamiento"
          className="img-fluid mx-auto d-block mb-4 licenciamiento-logo"
        />

   
        <div className="licenciamiento-periodo mb-4">
          <p className="fw-bold text-secondary">
            📅 <em>Aquí irá el período de vigencia del licenciamiento</em>
          </p>
        </div>

       
        <p className="fw-bold text-uppercase text-primary mt-4 fs-5">
          Trabajando juntos rumbo al licenciamiento 💪
        </p>
      </div>
    </section>
  );
};

export default Licenciamiento;
